<script setup>
import {reactive, onMounted, computed, onUnmounted, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import Vjsf from '@koumoul/vjsf'
import { v2compat } from '@koumoul/vjsf/compat/v2'

import { VForm } from 'vuetify/components'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import TaskTimedue from "@/Components/Timeline/Subcomponents/TaskTimedue.vue";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";
import {DatePicker} from "v-calendar";
const compName = 'ListComponent';
import dayjs from "dayjs";

const props = defineProps({
  claimId: String,
  personId: String,
  clientId: String
});

const taskRefs = ref({});
const newTaskForm = ref(null);

const data = reactive({
  datetime: {},
  permittedTasks: {
    'Adjuster': ["Make Contact", "Recontact", "Submit For Review", "Complete Inspection", "Make Corrections", "Review Supplement"],
    'Account Manager': ["Submit For Review", "Make Corrections", "Meet and Greet", "Complete Inspection", "Make Contact", "Recontact"],
    'Reviewer': ["Submit To Client / Close Claim","Complete Review"]
  },
  TASK_FORM_STATES: {
    COLLAPSED: 0,
    FORM_DETAILS: 1,
    CRUD_META: 2
  },
  config: {
    flatpickr: {
      inline: true,
      enableTime: true,
      minuteIncrement: 15,
      minDate: new Date()
    }
  },
  selectedItem: null,
  loading: false,
  formValid: false,
  defaultFormOptions: {
    debug: false,
    disableAll: false,
    autoFoldObjects: true
  },
  items: [],
  dateTimeRecordsLoaded: false,
  dateTimeRecords: {},
  newTaskTypes: ['template', 'custom'],
  newTaskType: 'template',
  isTemplateTask: false,
  newTask: {
    name: null,
    timedue: new Date().toISOString(),
    datestarted: null,
    complete: false
  },
  currentWorkflow: '',
  isTaskFormOpen: false,
  showCompleted: false
});

const taskTemplatesForCurrentWorkflow = computed(()=>{
  
  return data.taskTemplates.filter(tt => tt.workflow_handle === data.currentWorkflow)
});

const getPermittedTasks = (role) => {
  return role && data.permittedTasks[role] ? data.permittedTasks[role] : [];
}

const checkPermissions = (item) => {
  if(Permissions.checkPermissions(['tasks.admin'])){
    return true
  }
  else if(getPermittedTasks(item.role).indexOf(item.name) !== -1){
    return true
  }else{
    return false
  }
}

const closeNewTaskForm = () =>  {
  data.isTaskFormOpen = false
  data.newTask = {
    name: null,
    timedue: new Date().toISOString(),
    datestarted: null,
    complete: false
  }
  data.newTaskType = 0
}

const toggleFormState = (item, toggleClicked)  => {
  if(toggleClicked === 2){

    let d = new Date(item.timedue)
    d.setHours(12)
    d.setMinutes(0)
    d.setSeconds(0)
    d.setMilliseconds(0)
    item.newTimeDue = d //.toISOString()
  }

  if(getPermittedTasks(item.role).indexOf(item.name) !== -1 || Permissions.checkPermissions(['tasks.admin'])){
    if( item.formState === toggleClicked ) {
      item.formState = data.TASK_FORM_STATES.COLLAPSED
    } else {
      item.formState = toggleClicked
    }
    // $forceUpdate()
  }

}

const toggleFormStateOnCondition = (condition, item, toggleClicked) =>  {
  if(getPermittedTasks(item.role).indexOf(item.name) !== -1 || Permissions.checkPermissions(['tasks.admin'])){
    if( condition ) {
      return toggleFormState(item, toggleClicked)
    }
  }
}

const showError = (err) =>  {
  ToastUtil.error(err)
}

const showChange = (e) =>  {
}

const showInput = (e) =>  {
}

const showItem = (item) =>  {
  return data.showCompleted || item.timecompleted === null
}

const formatDate = (date, format) => {
  return dayjs(date).format(format);
}

const parseDate = (date) =>  {
  return new Date(date);
}

const hasForm = (item) =>  {
  return item.formjsonschema && Object.keys(item.formjsonschema).length > 0
}

const isComplete = (item) =>  {
  return item.timecompleted !== null
}

const tomorrow = () =>  {
  const d = new Date()
  d.setDate(d.getDate() + 1)
  return d
}

const decorateFormTasks = (tasks) =>  {
  let d = new Date()
  let nowDate = d.toDateString()
  let nowHours = d.getHours()
  let offsetHours = d.getTimezoneOffset() / 60
  let nowHoursMinusOffset = nowHours > offsetHours ? nowHours - offsetHours : 24 + (nowHours - offsetHours)
  let nowOffsetTime = nowHoursMinusOffset + ":" + d.getMinutes()
  tasks.forEach(i => {
    if( ! i.formState) { i.formState = data.TASK_FORM_STATES.COLLAPSED }
    if( ! i.timecompleted ) {
      if ( i.name === "Make Contact" || i.name === "Recontact" ) {
        data.dateTimeRecords[(i.id).toString()] = {
          datetime: null
        }
      }
    }
    // if( ! i.timecompleted ) {
    //     if ( i.name === "Complete Inspection" ) {
    //         data.dateTimeRecords[(i.id).toString()] = {
    //             datetime: d.toISOString()
    //         }
    //     }
    // }
    if( ! i.timecompleted ) {
      if ( i.name === "Complete Inspection" ) {
        if(i.formdata.datetime){
          let newDate = new Date(i.formdata.datetime)
          data.dateTimeRecords[(i.id).toString()] = {
            datetime: newDate.toISOString()
          }
        }else{
          data.dateTimeRecords[(i.id).toString()] = {
            datetime: d.toISOString()
          }
        }

      }
    }
  })
  data.dateTimeRecordsLoaded = true
}

const isLessThanToday = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set hours, minutes, seconds and milliseconds to 0 for accurate comparison
  const inputDate = new Date(date);
  inputDate.setHours(0, 0, 0, 0);

  return inputDate < today;
}

const updateStatus = (item) =>  {
  if(item.name === 'Make Contact' || item.name === 'Recontact'){
    item.formdata.datetime = data.dateTimeRecords[(item.id).toString()].datetime;

    if(item.formdata.datetime === undefined || item.formdata.datetime === null){
      if(item.formdata.contactOutcome === 'Yes'){
        ToastUtil.errorMsg('Please set appointment date/time.')
        return
      }
    }
    else if(isLessThanToday(item.formdata.datetime)){
      ToastUtil.errorMsg('Appointment date/time cannot be back dated earlier than today.')
      return
    }
  }

  if(item.name === 'Make Contact' || item.name === 'Recontact'){
    if(item.formdata.persontomeet === undefined || item.formdata.persontomeet === null){
      if(item.formdata.contactOutcome === 'Yes'){
        ToastUtil.errorMsg('Please set the person to meet.')
        return
      }
    }
  }

  if (item.name === "Submit For Review"){
    if(item.formdata.lossAmount === undefined || item.formdata.lossAmount === null){
      ToastUtil.errorMsg('Please enter a loss amount.');
      return
    }
  }

  const formData = {...item.formdata};
  item.timecompleted = new Date()
  item.completed = true;
  data.loading = true
  data.dateTimeRecordsLoaded = false

  if (item.name === "Make Contact" || item.name === 'Recontact') {
    formData.datetime = parseDate(formData.datetime).toISOString()
  }
  if (item.name === "Complete Inspection") {
    formData.datetime = parseDate(formData.datetime).toISOString()
  }

  item.formattedDateTime = formatTimestampByLocale(formData.datetime);
  ApiWrapper.post('tasks','update-status', {
    id: item.id,
    formData: formData,
    claimId: props.claimId || item.claimid,
    item: {...item, formdata: formData}
  })
      .then(response => {
        fetchData()
        activeComponentStore.notifyComponents(['appointments','tasks','claims','messages'],compName);
        data.loading = false
        if (item.name === "Submit For Review"){
          let pos = data.taskTemplates.findIndex(x => x.text === "Submit For Review");
          data.taskTemplates.splice(pos,1);
        }
        ToastUtil.successMsg('Updated task');

        if(response.updatedClaimStatusSymbility === true) {
          ToastUtil.successMsg(`Updated claim status in Symbility`);
        }

        if(response.thirdPartyError !== null) {
          ToastUtil.error(response.thirdPartyError);
        }
        else if(response.xactError === true) {
          ToastUtil.errorMsg('Error updating task in Xact');
        }
      })
      .catch(error => {
          ToastUtil.error(error);
          data.loading = false;
      })
}

const formatTimestampByLocale = (timestamp)  => {
  const date = new Date(timestamp)
  const timeOptions = {
    hour12: true,
    hour: "numeric",
    minute: "2-digit",
  }
  const dateOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    timeZoneName:'short'
  }
  return date.toLocaleString('en', { ...dateOptions, ...timeOptions })
}

const updateTimeDue = (item)  => {
  data.loading = true
  item.timedue = item.newTimeDue

  const str_timedue_with_tz = parseDate(item.newTimeDue).toISOString();
  ApiWrapper.post('tasks','update-time-due', {
    id: item.id,
    timedue: str_timedue_with_tz
  })
      .then(response => {
        reloadTasks()
        activeComponentStore.notifyComponents(['appointments','tasks'],compName);
        ToastUtil.successMsg('Updated task time due');
      })
      .catch(error => {
        ToastUtil.error(error);
        data.loading = false;
      })
      .finally(error => {
        item.formState = data.TASK_FORM_STATES.COLLAPSED
        data.loading = false
      })
}

const addTask = ()  => {
  newTaskForm.value.validate()
  if (data.newTask.name) {
    data.newTask.name.trim()
  } else {
    return
  }
  data.loading = true
  data.dateTimeRecordsLoaded = false
  data.isTaskFormOpen = false
  // const newTaskTypeName = data.newTaskTypes[data.newTaskType]
  const newTaskTypeName = data.isTemplateTask ? 'template' : data.newTaskTypes[data.newTaskType]
  data.newTask.timedue = parseDate(data.newTask.timedue).toISOString()
  ApiWrapper.post('tasks','create', {
    newTaskType: newTaskTypeName,
    newTodo: data.newTask,
    claimId: props.claimId,
    clientId: props.clientId,
    personId: props.personId
  })
      .then((response) => {
        let newItem = response.task;
        if(newItem.name === 'Make Contact'){
          newItem.formjsonschema = {
            "type": "object",
            "title": "Make Contact",
            "properties": {
              "contactOutcome": {
                "enum": [
                  "Yes",
                  "No, left voicemail",
                  "No answer"
                ],
                "type": "string",
                "title": "Did you schedule an appointment?",
                "default": "Yes"
              },
              "datetime": {
                "type": "string",
                "title": "Inspection date/time",
                "format": "date-time"
              },
              "persontomeet": {
                "type": "string",
                "title": "Person to meet",
                "minLength": 1,
                "description": "Full name"
              },
            }
          }
        }
        if(newItem.name === 'Recontact'){

          newItem.formjsonschema = {
            "type": "object",
            "title": "Recontact",
            "properties": {
              "contactOutcome": {
                "enum": [
                  "Yes",
                  "No, left voicemail",
                  "No answer"
                ],
                "type": "string",
                "title": "Did you schedule an appointment?",
                "default": "Yes"
              },
              "datetime": {
                "type": "string",
                "title": "Inspection date/time",
                "format": "date-time"
              },
              "persontomeet": {
                "type": "string",
                "title": "Person to meet",
                "minLength": 1,
                "description": "Full name"
              },
            }
          }
        }
        newItem.completed = false;
        let newItems = [newItem]
        decorateFormTasks(newItems)
        newItems[0].formjsonschema = mapSchema(newItems[0].formjsonschema);
        data.items.push(newItems[0])
        activeComponentStore.notifyComponents(['tasks'],compName);
        data.loading = false
        closeNewTaskForm()
        ToastUtil.successMsg('Created task');
      })
      .catch(err => {
        ToastUtil.error(err);
        data.loading = false;
      });
  data.newTodo = ''
}

const fetchData = ()  => {
  data.loading = true
  ApiWrapper.post('tasks','list', {
      claimId: props.claimId,
      clientId: props.clientId,
      personId: props.personId
    })
      .then(response => {
        for(let x in response.data){
          if(response.data[x].name === 'Make Contact'){
            response.data[x].formjsonschema = {
              "type": "object",
              "title": "Make Contact",
              "properties": {
                "contactOutcome": {
                  "enum": [
                    "Yes",
                    "No, left voicemail",
                    "No answer"
                  ],
                  "type": "string",
                  "title": "Did you schedule an appointment?",
                  "default": "Yes"
                },
                "datetime": {
                  "type": "string",
                  "title": "Inspection date/time",
                  "format": "date-time"
                },
                "persontomeet": {
                  "type": "string",
                  "title": "Person to meet",
                  "minLength": 1,
                  "description": "Full name"
                },
              }
            }
          }
          if(response.data[x].name === 'Recontact'){
            response.data[x].formjsonschema = {
              "type": "object",
              "title": "Recontact",
              "properties": {
                "contactOutcome": {
                  "enum": [
                    "Yes",
                    "No, left voicemail",
                    "No answer"
                  ],
                  "type": "string",
                  "title": "Did you schedule an appointment?",
                  "default": "Yes"
                },
                "datetime": {
                  "type": "string",
                  "title": "Inspection date/time",
                  "format": "date-time"
                },
                "persontomeet": {
                  "type": "string",
                  "title": "Person to meet",
                  "minLength": 1,
                  "description": "Full name"
                },
              }
            }
          }
          if(response.data[x].name === 'Submit For Review'){
            response.data[x].formjsonschema = {
              "type": "object",
              "title": "Loss Amount",
              "properties": {
                "lossAmount": {
                  "type": "number",
                  "title": "Loss Amount ($):"
                }
              },
              "options":{
                "indent": true,
                "validateOn":"submit",
                "density":"comfortable"
              }
            }
          }
        }

        response.data.forEach((item) => {
          item.formjsonschema = mapSchema(item.formjsonschema);
          item.formdata = item.formdata === null ? {} : item.formdata;
        });
        data.items = response.data;

        for(let i = 0; i < data.items.length; i++) {
          data.items[i].completed = isComplete(data.items[i]);
        }

        decorateFormTasks(data.items)

      })
      .catch((e)=>{
        ToastUtil.error(e);
        data.loading = false;
      })
      .finally(()=>{
        data.loading = false
      });
}

const fetchTaskTemplates = ()  => {
  let schema;
  if(props.personId) {
    schema = 'person';
  }
  else if(props.claimId) {
    schema = 'claims';
  }
  else if(props.clientId) {
    schema = 'clients';
  }

  ApiWrapper.post('tasks','list-task-templates', {
    schema: schema
  })
      .then(response => {
        data.taskTemplates = response.templates;
        data.workflows = response.workflows.map((workflow) => {
          workflow.title = workflow.text;
          return workflow;
        });
        if(response.workflows.length > 0) {
          data.currentWorkflow = response.workflows[0].value;
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
}

const reloadTasks  = ()  => {
  
  setTimeout(function () {
    fetchData()
  }, 5000)
}

const removeTask = (item)  => {
  let confirmDelete = confirm(`Are you sure you want to delete the '${item.name}' task?`)
  if( ! confirmDelete ) {
    return
  }

  ApiWrapper.post('tasks','delete', {
    id: item.id,
    claimId: props.claimId,
    clientId: props.clientId,
    personId: props.personId
  })
      .then((response) => {
        data.items = data.items.filter(task => { return task.id !== item.id }).map((item) => {
          item.formjsonschema = mapSchema(item.formjsonschema);
          return item;
        })
        activeComponentStore.notifyComponents(['tasks'],compName);
        ToastUtil.successMsg('Deleted task');
      })
      .catch(err => {
        ToastUtil.error(err);
      });
}

const mapSchema = (schema) => {
  if(!schema.properties) { return v2compat(schema);}

  for(const key in schema.properties) {
    if(schema.properties[key]) {
      const originalSchema = JSON.parse(JSON.stringify(schema.properties[key]));

      switch(key) {
        case 'datetime':
          schema.properties[key].layout = {
              "slots": {
                "component": "datetime"
              },
              "props": {
                originalSchema: originalSchema
              }
          };
          break;
        case 'timeliness':
        case 'quality':
        case 'attitude':
          schema.properties[key].layout = {
            "slots": {
              "component": key
            },
            "props": {
              originalSchema: originalSchema
            }
          };
          break;
      }
    }
  }

  return v2compat(schema);
}

onMounted(()=>{

  activeComponentStore.registerComponent(
      compName,
      [
        'updateTasks',
        'adjusters'
      ],
      reloadTasks
  );
  fetchData()
  fetchTaskTemplates()
});

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});

</script>

<template>
  <v-container fluid>
    <v-card>

      <v-toolbar density="compact" flat color="white">
        <v-toolbar-title>Tasks</v-toolbar-title>
        <v-progress-linear :active="data.loading" :indeterminate="data.loading" absolute bottom color="primary">
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-spacer></v-spacer>

        <v-switch density="compact" v-model="data.showCompleted" label="show completed" color="info" value="info" hide-details>
        </v-switch>

        <v-divider class="mx-4" inset vertical></v-divider>

        <v-btn size="small" variant="elevated" v-if="!data.isTaskFormOpen && Permissions.checkPermissions(['tasks.create'])" color="primary"
               @click="data.isTaskFormOpen = true; data.newTask.timedue = tomorrow()">
          New Task
        </v-btn>
      </v-toolbar>

      <div v-if="data.isTaskFormOpen">
        <v-card flat>
          <v-form ref="newTaskForm">
            <v-tabs v-model="data.newTaskType" grow>
              <v-tab value="template">Create from template</v-tab>
              <v-tab value="custom">Custom</v-tab>
            </v-tabs>
            <v-container>
              <v-row density="compact">
                <v-col>
                  <v-tabs-window v-model="data.newTaskType">
                    <v-tabs-window-item key="template" value="template">
                      <v-select density="compact" class="px-5 mt-4" v-model="data.currentWorkflow" :items="data.workflows"
                                label="Choose a workflow" onchange="">
                      </v-select>
                      <v-list-item item-type="subheader">Choose a task below</v-list-item>
                      <v-divider></v-divider>
                      <v-list>
                        <v-list-item
                            class="v-list--select-list"
                            density="compact"
                            v-for="taskTemplate in taskTemplatesForCurrentWorkflow"
                            :key="taskTemplate.text"
                            :active="data.newTask.name === taskTemplate.value"
                            @click="data.newTask.name = taskTemplate.value; data.isTemplateTask = true"
                        >
                            <v-list-item-title >
                              {{taskTemplate.text}}
                            </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-tabs-window-item>
                    <v-tabs-window-item key="custom" value="custom">
                      <v-container>
                        <v-row density="compact">
                          <v-col>
                            <v-text-field density="compact" label="Enter custom task"
                                          v-model="data.newTask.name"
                                          :rules="[value => !!value || 'Required.']"
                                          @click="data.isTemplateTask = false"
                            >
                            </v-text-field>
                            <v-card-text>Time due</v-card-text>
                            <flat-pickr class="form-control"
                                        v-model="data.newTask.timedue"
                                        :config="data.config.flatpickr">
                            </flat-pickr>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-tabs-window-item>
                  </v-tabs-window>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions>
              <v-btn size="small" variant="elevated" class="error ml-2" @click="closeNewTaskForm()">Cancel</v-btn>
              <v-btn size="small" class="primary ml-2" variant="text" @click="addTask">Save</v-btn>
            </v-card-actions>
          </v-form>

          <v-divider></v-divider>
        </v-card>
      </div>

      <v-list density="compact" flat class="py-0">
        <template v-for="(item, index) in data.items">
          <template v-if="showItem(item)">
            <v-list-item density="compact" :key="item.id+item.name" >
                <v-container>
                  <v-row density="compact">
                    <v-col cols="1">
                      <v-checkbox
                          class="mt-1"
                          v-if="(item.timecompleted || !hasForm(item)) && checkPermissions(item)"
                          :disabled="isComplete(item)"
                          :value="true"
                          v-model="item.completed"
                          color="primary"
                          @change="updateStatus(item)"
                      >
                      </v-checkbox>
                      <v-icon
                          class="mt-1"
                          v-else-if="hasForm(item) && !isComplete(item) && checkPermissions(item)"
                          @click="toggleFormStateOnCondition(item.formState !== data.TASK_FORM_STATES.FORM_DETAILS, item, data.TASK_FORM_STATES.FORM_DETAILS)"
                      >
                        mdi-checkbox-blank-outline
                      </v-icon>
                      <v-checkbox
                          class="mt-1"
                          v-else-if="checkPermissions(item)"
                          input-value="true"
                          disabled
                          @click="toggleFormState(item, data.TASK_FORM_STATES.FORM_DETAILS)"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="8">
                      <v-list-item-title
                          class="mt-5"
                          v-bind:class="[item.timecompleted ? 'text--disabled' : '', 'ma-2']"
                          @click="toggleFormStateOnCondition(hasForm(item), item, data.TASK_FORM_STATES.FORM_DETAILS)">
                        {{item.name}}
                      </v-list-item-title>
                      <span v-if="item.formdata?.createdBy"> <small> Completed By: {{item.formdata.createdBy}} </small></span>
                    </v-col>
                    <v-col cols="3">
                      <v-list-item-action class="mt-4">
                        <v-chip v-if="isComplete(item)"
                                color="blue" label text-color="white">
                          <v-icon left>mdi-calendar</v-icon>
                          <span
                              v-text="formatDate(item.timecompleted,'MM/DD/YYYY h:mm A')"></span>
                        </v-chip>
                        <task-timedue
                            v-else-if="item.timedue !== null"
                            :timedue="item.timedue"
                            v-on:click="toggleFormState(item, data.TASK_FORM_STATES.CRUD_META)">
                        </task-timedue>
                      </v-list-item-action>
                    </v-col>
                  </v-row>
                  <v-row density="compact">
                    <v-col>
                      <v-list-item v-if="item.formState === data.TASK_FORM_STATES.FORM_DETAILS">
                        <v-form v-if="hasForm(item)" v-model="data.formValid" :ref="(el) => (taskRefs[`taskForm${index}`] = el)">
                          <vjsf v-if="isComplete(item)" v-model="item.formdata"
                                 :schema="item.formjsonschema"
                                 :options="{ disableAll: true }">
                          </vjsf>
                          <vjsf v-else
                                  v-model="item.formdata"
                                 :schema="item.formjsonschema"
                                 :options="data.defaultFormOptions"
                          >
                            <template v-slot:[`datetime`]="{node}">
                              <div class="theme--light v-label text-caption">
                                {{node.props.originalSchema.title}}
                              </div>
                              <br/>
                              <DatePicker
                                  v-model="data.dateTimeRecords[(item.id).toString()].datetime"
                                  mode="dateTime"
                                  :rules="{
                                    minutes:
                                    [0, 15, 30, 45],
                                  }"
                                  @update:modelValue="data.dateTimeRecords[(item.id).toString()].datetime=$event"
                              />
                            </template>
                            <template v-slot:[`attitude`]="{node, statefulLayout}">
                              <v-card-title class="primary--text">
                                {{node.props.originalSchema.title}}
                              </v-card-title>
                              <v-card-actions class="ml-2 pb-4 pt-0">
                                <v-rating
                                    v-model="node.data"
                                    color="warning"
                                    background-color="warning"
                                    half-increments
                                    hover
                                    @update:modelValue="event => statefulLayout.input(node, event)"
                                  >
                                </v-rating>
                              </v-card-actions>
                            </template>
                            <template v-slot:[`quality`]="{node, statefulLayout}">
                              <v-card-title class="primary--text">
                                {{node.props.originalSchema.title}}
                              </v-card-title>
                              <v-card-actions class="ml-2 pb-4 pt-0">
                                <v-rating
                                    v-model="node.data"
                                    color="warning"
                                    background-color="warning"
                                    half-increments
                                    hover
                                    @update:modelValue="event => statefulLayout.input(node, event)"
                                >
                                </v-rating>
                              </v-card-actions>
                            </template>
                            <template v-slot:[`timeliness`]="{node, statefulLayout}">
                              <v-card-title class="primary--text">
                                {{node.props.originalSchema.title}}
                              </v-card-title>
                              <v-card-actions class="ml-2 pb-4 pt-0">
                                <v-rating
                                    v-model="node.data"
                                    color="warning"
                                    background-color="warning"
                                    half-increments
                                    hover
                                    @update:modelValue="event => statefulLayout.input(node, event)"
                                >
                                </v-rating>
                              </v-card-actions>
                            </template>
                          </vjsf>
                          <v-card-actions v-if="!isComplete(item)">
                            <v-btn size="small" variant="elevated" color="primary" @click="taskRefs[`taskForm${index}`].validate() && updateStatus(item)">
                              Complete Task
                            </v-btn>
                          </v-card-actions>
                        </v-form>
                      </v-list-item>
                      <v-list-item v-else-if="item.formState === data.TASK_FORM_STATES.CRUD_META">
                        <!-- <v-date-picker v-model="picker"></v-date-picker> -->
                        <flat-pickr v-if="!item.timecompleted" class="form-control"
                                    v-model="item.newTimeDue" :config="data.config.flatpickr">
                        </flat-pickr>
                        <!-- <v-btn icon color="red lighten-1"
                                @click.stop="removeTodo(item)">
                                <v-icon>clear</v-icon>
                            </v-btn> -->
                        <v-container>
                          <v-alert
                              text="For a selected date beyond today, the time due will be recorded as 12:00 noon Eastern Time for that day."
                              color="secondary"
                              border="start"
                              border-color="info"
                              variant="outlined"
                          ></v-alert>

                          <v-row density="compact" class="d-flex flex-row-reverse">
                            <v-card-actions>
                              <v-btn v-if="Permissions.checkPermissions(['tasks.delete'])" size="small" variant="elevated" @click.stop="removeTask(item)">
                                Delete
                                <!-- <v-icon>delete</v-icon> -->
                              </v-btn>
                              <v-btn size="small" variant="elevated" color="error" @click="toggleFormState(item, data.TASK_FORM_STATES.CRUD_META)">
                                Cancel
                                <!-- <v-icon>delete</v-icon> -->
                              </v-btn>
                              <v-btn size="small" v-if="!item.timecompleted && Permissions.checkPermissions(['tasks.update-time-due'])" class="primary ml-2"
                                     variant="text" @click="updateTimeDue(item)">
                                Update</v-btn>
                            </v-card-actions>
                          </v-row>
                        </v-container>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-container>
            </v-list-item>
          </template>

          <v-divider v-if="index + 1 < data.items.length && (data.showCompleted || item.timecompleted === null)"
                     :key="index"></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-container>
</template>

<style scoped>
  [v-cloak] {
    display: none;
  }
  .container {
    padding: 5px;
  }

  .v-list--select-list {
    max-height: 200px;
    overflow-y: auto;
  }

  .v-list-group__header__append-icon {
    display: none;
  }

  .v-list-item__content {
    align-self: flex-start;
  }

  .v-list-item__action {
    align-self: flex-start;
    margin: 0;
  }

  .v-expansion-panel::before {
    box-shadow: none;
  }

  .v-expansion-panel-header__icon {
    display: none
  }

  input.flatpickr-input {
    display: none;
  }

  i.v-icon.notranslate.mdi.mdi-view-list-outline.theme--light::before {
    margin-right: .5rem;
  }

  div.v-list-item-icon {
    margin-bottom: .25rem !important;
  }

  .vjsf-property-datetime {
    z-index: 1;
  }
</style>